import Chip from '@mui/material/Chip';
import type { FunctionComponent, MouseEventHandler, ReactElement } from 'react';

type CountChipProps = {
    readonly ariaLabel?: string;
    readonly backgroundColor: string;
    readonly clickable?: boolean;
    readonly count: number;
    // biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration
    readonly icon: ReactElement<any>;
    readonly onClick?: MouseEventHandler;
};

export const CountChip: FunctionComponent<CountChipProps> = ({
    ariaLabel,
    backgroundColor,
    clickable,
    count,
    icon,
    onClick,
}) => (
    <Chip
        aria-label={ariaLabel}
        clickable={clickable}
        icon={icon}
        label={count}
        sx={{
            '& .MuiChip-icon': {
                color: 'background.default',
                marginLeft: '0px',
                marginRight: '0px',
            },
            '& .MuiChip-label': {
                paddingLeft: '6px',
            },
            backgroundColor,
            color: 'background.default',
            fontSize: '16px',
            fontWeight: 'bold',
            paddingBottom: '9px',
            paddingLeft: '10px',
            paddingTop: '9px',
        }}
        onClick={onClick}
    />
);
